<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Организация</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="handleSelect($event)"
  >
    <mat-option *ngFor="let org of filteredOptions | async | async" [value]="org">
      {{ org.name }}
    </mat-option>
    <mat-option *ngIf="(filteredOptions | async | async)?.length === 0" [value]="control.value">
      Создать {{ control.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
